<template>
  <div class="white-background-section">
    <div class="container">
      <div class="mb-5">
        <h1 class="how-do-i-title">{{howText.heading}}</h1>
        <p class="how-do-i-sub">{{howText.sub_1}}</p>
        <p class="how-do-i-sub">{{howText.sub_2}}</p>
        <div class="apply-btn">
          <el-button class="btn-text" type="primary" size="small" @click="$router.push({name: 'Signup GS'})">Apply to become a service</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      howText: {
        heading: "Ready to become a service on CWB?",
        sub_1: "Support Scotland’s future business leaders by sharing your experiences.",
        sub_2: "Apply here – you’ll need to provide some detail on your skills, business background and how you could support Scotland’s economic ambitions."
      }
    };
  }
};
</script>
<style >
</style>
